import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

type StringEnum = Readonly<Record<string, string>>;

export const createStringEnumSchema = <const T extends StringEnum>(values: T) =>
  z.enum(values).transform((value): `${T[keyof T]}` => `${value}`);

export const selfServeOnboardingStepsConfigurationFieldSchemas = {
  // HubSpot writes these fields even when they are absent from its payload, so
  // persisted configurations can contain null for any optional field.
  skipBilling: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  skipCoverage: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  skipPricing: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  billingRequired: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  enableOnboardingQuestionsForSE: z
    .boolean()
    .nullish()
    .meta({ privacy: privacy.nonPii }),
  skipInternational: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  skipPackaging: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  skipAutomations: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  customCoveragePrice: z.number().nullish().meta({ privacy: privacy.nonPii }),
};
